import get from 'lodash/get'
import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'workflow',
    rolStages: [],
    casoStages: [],
    stagesGestionados: []
  }),
  getters: {
    rolStages: state => state.rolStages,
    casoStages: state => state.casoStages,
    stagesGestionados: state => state.stagesGestionados
  },
  mutations: {
    setRolStages (state, data) {
      state.rolStages = data
    },
    setCasoStages (state, data) {
      state.casoStages = data
    },
    // Agrego la mutación para setStagesGestionados
    setStagesGestionados (state, data) {
      state.stagesGestionados = data // Guarda los datos de las etapas gestionadas
    }
  },
  actions: {
    async getRolStages ({ commit, state }) {
      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.get(`${state.endpoint}/myinbox`)
        const data = get(response, 'data.data', [])
        commit('setLoading', -1, { root: true })
        commit('setRolStages', data)

        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    },
    async getCasoStages ({ commit, state }, params) {
      // if (id <= 0) {
      //     return Promise.resolve()
      // }
      const force = get(params, 'force', false)
      const query = get(params, 'query', {})
      if (force || !state.fetched || isEmpty(state.all)) {
        commit('setLoading', 1, { root: true })
        try {
          const response = await axios.get(`${state.endpoint}/stages`, { params: query })
          const data = get(response, 'data.data', [])
          commit('setLoading', -1, { root: true })
          commit('setCasoStages', data)

          return data
        } catch (e) {
          commit('setLoading', -1, { root: true })
          return Promise.reject(e)
        }
      }
    },
    async moveCasoStage ({ commit, state }, { id, action, urlorigin, idbifurcacion }) {
      if (id <= 0) {
        return Promise.reject(new Error())
      }

      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.post(`${state.endpoint}/${action}`, { id, urlorigin, idbifurcacion })
        const data = get(response, 'data.data', [])
        commit('setLoading', -1, { root: true })
        commit('casos/setUpdate', data, { root: true })

        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    },
    //Nuevo metodo para llamar servicio para los pasos gestionados o no gestionados 
    async getCasoStagesGestionados({ commit, state }, params) {
      const force = get(params, 'force', true)
      const query = get(params, 'query', {})
      const id = get(params, 'id', 0)

      if (force || !state.fetched || isEmpty(state.all)) {
        commit('setLoading', 1, { root: true })
        try {
    
          const response = await axios.get(`${state.endpoint}/stages/gestionados?id=${id}`)
          const data = get(response, 'data.data', [])
    
          if (get(response, 'data.code') === 422) {
            commit('setLoading', -1, { root: true })
            return Promise.reject(new Error(get(response, 'data.message', 'Error inesperado')))
          }

          commit('setLoading', -1, { root: true })
          commit('setStagesGestionados', data)
          return data
        } catch (e) {
          commit('setLoading', -1, { root: true })
          return Promise.reject(e)
        }
      }
    }
  }
}
